import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\tDescription *\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_3 = { class: "invalid-feedback" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tSubject (optional - default is the description)\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_7 = { class: "invalid-feedback" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tBody (optional)\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_10 = { class: "float-end" };
const _hoisted_11 = { id: "current" };
const _hoisted_12 = { id: "maximum" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_14 = {
    key: 1,
    class: "col-xs-12 col-sm-12 col-md-12 bottom10"
};
const _hoisted_15 = { class: "col-xs-12 col-sm-2 col-md-2 border-1 bottom10" };
const _hoisted_16 = { class: "col-xs-12 col-sm-10 col-md-10" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", { class: "mt-2 mb-0 me-2" }, "Starting at:", -1 /* HOISTED */);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_20 = { class: "d-flex" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label me-2 mt-2" }, "\r\n\t\t\t\t\t\t\tFormat:\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_22 = {
    class: "input-group top_search",
    style: { "width": "150px" }
};
const _hoisted_23 = { class: "d-flex mb-2 w-100" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label ms-2 me-3 mt-2 text-nowrap" }, "\r\n\t\t\t\t\t\t\tFile Name:\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_25 = { class: "w-100" };
const _hoisted_26 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_27 = { class: "float-end float-start-sm" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-floppy-o",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_b_form_radio = _resolveComponent("b-form-radio");
    const _component_b_form_radio_group = _resolveComponent("b-form-radio-group");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_ContactsVue = _resolveComponent("ContactsVue");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        class: "modal-form-lg",
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.showModal) = $event)),
        "header-bg-variant": "normal",
        size: "lg"
    }, {
        title: _withCtx(() => [
            _createTextVNode("\r\n\t\t\tReport Scheduler\r\n\t\t")
        ]),
        footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.save
                }, {
                    default: _withCtx(() => [
                        _hoisted_28,
                        _createTextVNode(" Save\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _createTextVNode(),
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "secondary",
                    onClick: _ctx.cancel
                }, {
                    default: _withCtx(() => [
                        _hoisted_29,
                        _createTextVNode(" Cancel\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
            ])
        ]),
        default: _withCtx(() => [
            _createTextVNode(),
            _createVNode(_component_b_container, { clearfix: "" }, {
                default: _withCtx(() => {
                    var _a, _b, _c, _d, _e, _f;
                    return [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_1, [
                                _hoisted_2,
                                _createTextVNode(),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.descriptionVal, {
                                    name: "description",
                                    type: "text",
                                    maxlength: "150",
                                    modelValue: _ctx.model.description,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.model.description) = $event)),
                                    modelModifiers: { trim: true },
                                    class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.description }
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("div", _hoisted_3, "\r\n\t\t\t\t\t\t* Please enter a description.\r\n\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.description]
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.showEmailDetails)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _hoisted_6,
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_input, _mergeProps(_ctx.subjectVal, {
                                            name: "subject",
                                            type: "text",
                                            maxlength: "150",
                                            modelValue: _ctx.model.subject,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.model.subject) = $event)),
                                            modelModifiers: { trim: true },
                                            class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.subject }
                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("div", _hoisted_7, "\r\n\t\t\t\t\t\t\t* Max length is 150 characters.\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                            [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.subject]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_8, [
                                        _hoisted_9,
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_textarea, _mergeProps(_ctx.bodyVal, {
                                            name: "body",
                                            type: "text",
                                            modelValue: _ctx.model.body,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.model.body) = $event)),
                                            modelModifiers: { trim: true },
                                            rows: "20",
                                            class: { 'is-invalid': _ctx.errors && _ctx.errors.body && _ctx.attemptedSave },
                                            maxlength: _ctx.maxBodyLength
                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "maxlength"]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getBodyLength(_ctx.model.body)), 1 /* TEXT */),
                                            _createTextVNode(),
                                            _createElementVNode("span", _hoisted_12, "/ " + _toDisplayString(_ctx.maxBodyLength), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("a", {
                                            class: "blue",
                                            href: "#",
                                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.showEmailDetails = false), ["prevent", "stop"]))
                                        }, "Hide email details")
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("a", {
                                        class: "blue",
                                        href: "#",
                                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.showEmailDetails = true), ["prevent", "stop"]))
                                    }, "Show email details")
                                ])),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_b_form_radio_group, {
                                    modelValue: _ctx.model.period,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.model.period) = $event)),
                                    stacked: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_b_form_radio, { value: "1" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("Once")
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_radio, {
                                            value: "2",
                                            disabled: !_ctx.canSchedule
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("Daily")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_radio, {
                                            value: "3",
                                            disabled: !_ctx.canSchedule
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("Weekly")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_radio, {
                                            value: "4",
                                            disabled: !_ctx.canSchedule
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("Monthly")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_b_input_group, {
                                    class: _normalizeClass(['top_search']),
                                    style: { "width": "350px" }
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_17,
                                        _createTextVNode(),
                                        _createVNode(_component_flat_pickr, {
                                            class: "form-control",
                                            modelValue: _ctx.startDate,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.startDate) = $event)),
                                            config: _ctx.datePickerConfig,
                                            placeholder: "Start"
                                        }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group_append, null, {
                                            default: _withCtx(() => [
                                                _hoisted_18
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createTextVNode(),
                                (_ctx.model.period >= 3)
                                    ? (_openBlock(), _createBlock(_component_b_input_group, { key: 0 }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_b_form_radio_group, {
                                                modelValue: _ctx.model.dayoftheweek,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.model.dayoftheweek) = $event))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_form_radio, { value: "0" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("Sunday")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_form_radio, { value: "1" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("Monday")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_form_radio, { value: "2" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("Tuesday")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_form_radio, { value: "3" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("Wednesday")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_form_radio, { value: "4" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("Thursday")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_form_radio, { value: "5" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("Friday")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_form_radio, { value: "6" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("Saturday")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                (_ctx.hasReportFormats)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_21,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_22, [
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.reportFormat,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.reportFormat) = $event)),
                                                options: _ctx.reportFormats,
                                                "track-by": "value",
                                                label: "text",
                                                showLabels: false,
                                                placeholder: "Select a format",
                                                class: "multiselect-small"
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_23, [
                                    _hoisted_24,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createVNode(_component_b_form_input, _mergeProps(_ctx.fileNameVal, {
                                            name: "fileName",
                                            type: "text",
                                            placeholder: "(Default)",
                                            maxlength: "150",
                                            modelValue: _ctx.model.reportFileName,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.model.reportFileName) = $event)),
                                            modelModifiers: { trim: true },
                                            class: ['mb-0', { 'is-invalid': (_e = _ctx.errors) === null || _e === void 0 ? void 0 : _e.fileName }]
                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("div", { class: "invalid-feedback d-block" }, _toDisplayString(_ctx.errors.fileName), 513 /* TEXT, NEED_PATCH */), [
                                            [_vShow, (_f = _ctx.errors) === null || _f === void 0 ? void 0 : _f.fileName]
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        (_ctx.showModal)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createVNode(_component_ContactsVue, {
                                    filterOnlyContactsWithEmail: true,
                                    isReport: true,
                                    contactIds: _ctx.model.contactIds,
                                    "onUpdate:contactIds": _cache[10] || (_cache[10] = ($event) => ((_ctx.model.contactIds) = $event)),
                                    contactGroupIds: _ctx.model.contactGroupIds,
                                    "onUpdate:contactGroupIds": _cache[11] || (_cache[11] = ($event) => ((_ctx.model.contactGroupIds) = $event))
                                }, null, 8 /* PROPS */, ["contactIds", "contactGroupIds"])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ];
                }),
                _: 1 /* STABLE */
            }),
            _createTextVNode()
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]));
}
